import UpdateEcpProjectsForm from "../../forms/ecp-projects/UpdateEcpProjectsForm"

export default function EcpWorkflowSettings({project, mutateEcpProject, setWorkflowNavigation, setIsPulling}) {
    return (
        <>
        <div className="SECTION ECP-WORKFLOW-SETTINGS">
            <UpdateEcpProjectsForm project={project} mutateEcpProject={mutateEcpProject} setWorkflowNavigation={setWorkflowNavigation} setIsPulling={setIsPulling}/>
        </div>
        </>
    )
}